import { render, staticRenderFns } from "./recommendedList.vue?vue&type=template&id=2df23552&scoped=true"
import script from "./recommendedList.vue?vue&type=script&lang=js"
export * from "./recommendedList.vue?vue&type=script&lang=js"
import style0 from "./recommendedList.vue?vue&type=style&index=0&id=2df23552&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df23552",
  null
  
)

export default component.exports